export default __webpack_public_path__ + "731f65a8e62f04e1bf473a16721d1938.otf";